import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { CalculatorProvider } from './context/CalculatorContext';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/Home/Home';
import Contact from './pages/Contact/Contact';
import Calculator from './pages/Calculator/Calculator';
import Results from './pages/Results/Results';

function App() {
  return (
    <CalculatorProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Ruta pública - No requiere protección */}
            <Route path="/" element={<Home />} />
            
            {/* Contact - No protegida, aquí se acepta la política */}
            <Route path="/contact" element={<Contact />} />
            
            {/* Rutas protegidas - Requieren aceptación de política */}
            <Route 
              path="/calculator" 
              element={
                <ProtectedRoute>
                  <Calculator />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/results" 
              element={
                <ProtectedRoute>
                  <Results />
                </ProtectedRoute>
              } 
            />
          </Routes>
        </div>
      </Router>
    </CalculatorProvider>
  );
}

export default App;